import styled from '@emotion/styled'
import { AnimatedTitle } from 'app/components/Common/Animation/AnimatedTitle'
import { styles } from 'app/theme'
import React, { memo } from 'react'

export interface Props {
  description?: string
  title?: string
}

export const Intro = memo(function Intro({ description, title }: Props) {
  if (!title) {
    return null
  }

  return (
    <Container>
      {title ? <Title delayChildren={1} tag="h1" text={title} /> : null}

      {description ? (
        <Description delayChildren={1} text={description} />
      ) : null}
    </Container>
  )
})

const Container = styled.section`
  max-width: 53rem;
  margin: auto;
  padding-top: 10rem;
  text-align: center;

  @media (max-width: 1199px) {
    max-width: none;
    padding: 7rem 2rem 0;
  }
`

const Title = styled(AnimatedTitle)`
  ${styles.label}
`

const Description = styled(AnimatedTitle)`
  ${styles.claim}
`
